<template>
  <div>
    <div class="d-flex justify-space-between justify-center">
      <!--Sorting-->
      <v-skeleton-loader
        v-if="options.hasSorting"
        :loading="loading"
        width="60px"
        type="avatar"
      >
        <v-menu fixed>
          <template #activator="{ props }">
            <div v-bind="props">
              <v-tooltip location="top">
                <!-- eslint-disable-next-line  vue/no-template-shadow -->
                <template #activator="{ props }">
                  <v-icon
                    size="large"
                    class="mouse-cursor"
                    :class="{ active: !isSortHovered }"
                    v-bind="props"
                    @mouseenter="isSortHovered = true"
                    @mouseleave="isSortHovered = false"
                  >
                    fas fa-sort-amount-up-alt
                  </v-icon>
                </template>
                <span>{{ listControllerData.sort }}</span>
              </v-tooltip>
              <!-- eslint-enable-next-line  vue/no-template-shadow -->
            </div>
          </template>
          <sorting />
        </v-menu>
      </v-skeleton-loader>
      <div v-else style="width: 60px" />
      <!--Pagination-->
      <v-skeleton-loader
        v-if="options.hasPagination"
        :loading="loading"
        width="100%"
        type="list-item"
      >
        <Pagination :total-pages="totalPages" :current-page="currentPage" />
      </v-skeleton-loader>
      <div v-else style="width: 100%" />
      <!--Stack or Column list toggle buttons-->
      <div class="d-flex flex-row align-start">
        <!--Stack or Column list toggle buttons-->
        <div class="d-flex flex-row align-center">
          <div v-if="options.hasListType" class="d-flex">
            <v-skeleton-loader :loading="loading" type="avatar">
              <v-tooltip location="top">
                <template #activator="{ props }">
                  <v-icon
                    size="large"
                    :class="[{ active: isColumnList }, 'mr-2']"
                    v-bind="props"
                    @click="changeListType('stackList')"
                  >
                    fas fa-list
                  </v-icon>
                </template>
                <span>{{ listControllerData.stackList }}</span>
              </v-tooltip>
            </v-skeleton-loader>
            <v-skeleton-loader :loading="loading" type="avatar">
              <v-tooltip location="top">
                <template #activator="{ props }">
                  <v-icon
                    size="large"
                    :class="{ active: !isColumnList }"
                    v-bind="props"
                    @click="changeListType('columnList')"
                  >
                    fas fa-th
                  </v-icon>
                </template>
                <span>{{ listControllerData.gridList }}</span>
              </v-tooltip>
            </v-skeleton-loader>
          </div>
          <div v-else style="width: 70px" />
        </div>
      </div>
    </div>
    <HitCount />
    <SummaryDownload />
  </div>
</template>

<script>
import { mapState } from "vuex";

import listControllerData from "@/data/ListControllerData.json";

import HitCount from "./HitCount";
import Pagination from "./Pagination";
import Sorting from "./Sorting";
import SummaryDownload from "./SummaryDownload";

export default {
  name: "ListController",
  components: { HitCount, SummaryDownload, Pagination, Sorting },
  props: {
    options: {
      type: Object,
      default: null,
    },
  },
  emits: ["ChangeListType"],
  data() {
    return {
      showMenu: false,
      listControllerData: listControllerData,
      isSortHovered: false,
      isColumnList: false, // need to go to store to have them synced in everywhere.
    };
  },
  computed: {
    ...mapState("records", ["totalPages", "loading", "currentPage"]),
  },
  methods: {
    changeListType: function (listType) {
      listType === "stackList"
        ? (this.isColumnList = false)
        : (this.isColumnList = true);
      this.$emit("ChangeListType", this.isColumnList);
    },
  },
};
</script>

<style scoped>
.active {
  color: lightgrey;
}

.theme--light.v-icon:focus::after {
  opacity: 0;
}
</style>
